import * as Sentry from "@sentry/react";
import { omit } from "ramda";

import { createLocalAxios } from "../../lib/api.js";
import apiMessages from "../../lib/apiMessages.js";

import {
  loadingNotifications,
  loadingNotificationsDone,
  setNotifications,
} from "./slice.js";

export const fetchUserNotifications =
  ({ page = 1, pageSize = 10 }) =>
  async (dispatch, getState) => {
    dispatch(loadingNotifications());
    const localAxios = createLocalAxios(getState);
    const url = `notifications/notifications?page=${page}&page_size=${pageSize}`;

    let response;
    try {
      response = await localAxios.get(url);
    } catch (error) {
      console.error("Error while fetching the user notifications:", error);
      Sentry.captureException(error);
      throw error;
    } finally {
      await dispatch(loadingNotificationsDone());
    }

    await dispatch(setNotifications(response.data.messages));

    return response.data.pages;
  };

export const saveUserNotification =
  (values, userNotificationId) => async (dispatch, getState) => {
    const localAxios = createLocalAxios(getState);
    const url = userNotificationId
      ? `notifications/notification/${userNotificationId}`
      : `notifications/notification`;
    const body = omit(["id", "createdAt", "updatedAt"], values);

    let response;
    try {
      if (userNotificationId) {
        response = await localAxios.patch(url, body);
      } else {
        response = await localAxios.post(url, body);
      }
    } catch (error) {
      console.error("Error while saving the user notification:", error);
      Sentry.captureException(
        new Error(
          `Something went wrong: saveUserNotification post/patch-> ${error}`,
        ),
      );
      throw error;
    }

    if (response.data.message !== apiMessages.MSG_SUCCESS) {
      throw new Error(response.data.message);
    }

    return response.data;
  };

export const removeUserNotification = (id) => async (dispatch, getState) => {
  const localAxios = createLocalAxios(getState);
  const url = `notifications/notification/${id}`;

  try {
    await localAxios.delete(url);
  } catch (error) {
    console.error(`Error deleting software notification: ${error}`);
    Sentry.captureException(
      new Error(`Something went wrong: removeSoftwareNotification -> ${error}`),
    );
  }
};

export const fetchUserNotificationById = (id) => async (dispatch, getState) => {
  const localAxios = createLocalAxios(getState);
  const url = `notifications/notification/${id}`;

  let response;
  try {
    response = await localAxios.get(url);
  } catch (error) {
    console.error("Error while fetching the user notification by id:", error);
    new Error(
      `Something went wrong: fetchUserNotificationById get -> ${error}`,
    );
  }

  dispatch(setNotifications([response.data]));
  return response.data;
};
